import { type AxiosResponse } from "axios"
import Util from "../util"
import httpClient from "../http/interceptors"

export interface IntReqPublishOffer {
  asset: {
    id?: string
    properties?: {
      [key: string]: any
    }
    privateProperties?: {
      [key: string]: any
    }
    dataAddress?: {
      properties: {
        [key: string]: any
      }
    }
  }
  restConnection: {
    type: string // e.g., "NONE"
    user_name?: string
    password?: string
    client_id?: string
    client_secret?: string
    token_url?: string
    rest_url?: string
  }
  accessPolicyId: string
  usagePolicyId: string
  connectorIds: string[]
}

export interface IntResponsePublishOffer {
  correlationId: string
  message: string
}

export interface IntReqPolicies {
  searchFields?: {
    name?: string
    type?: string
    isDeleted?: boolean
  }
  querySpec?: {
    page?: number
    size?: number
    sortFields?: {
      [key: string]: string
    }
  }
}

export interface IntFetchAssetPayload {
  correlationId?: string
  connectorId?: string
  querySpec?: {
    page?: number
    size?: number
    sortFields?: {
      [key: string]: string
    }
  }
}

const dgkServices = {
  getConnectors: (): Promise<AxiosResponse> => {
    return httpClient.get(Util.getRestApiUrl("connector-info/list", "dgk"))
  },
  publishOffer: (payload: IntReqPublishOffer): Promise<AxiosResponse<IntResponsePublishOffer>> => {
    return httpClient.post(Util.getRestApiUrl("provider/publish-offer", "dgk"), {
      ...payload
    })
  },
  getPolicies: (payload: IntReqPolicies) => {
    return httpClient.post(Util.getRestApiUrl("policydefinitions/request", "dgk"), {
      ...payload
    })
  },
  fetchAssetsUploadHistory: (payload: IntFetchAssetPayload): Promise<AxiosResponse> => {
    return httpClient.post(Util.getRestApiUrl("provider/upload-history", "dgk"), {
      ...payload
    })
  }
}

export default dgkServices
